import React, { useState } from 'react';
import { Button, useTheme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { AddMenu } from './AddMenu';

export const AddMenuButton = () => {
	const theme = useTheme();
	const [anchorEl, setAnchorEl] = useState(null);

	const handleOpen = (event) => setAnchorEl(event.currentTarget);
	const handleClose = () => setAnchorEl(null);

	return (
		<>
			<Button
				variant='outlined'
				size='small'
				endIcon={<KeyboardArrowDownIcon />}
				onClick={handleOpen}
				aria-controls='add-menu-appbar'
				aria-haspopup='true'
				sx={theme.palette.mode === 'dark' ? { color: '#fff' } : undefined}
			>
				Add
			</Button>
			<AddMenu anchorEl={anchorEl} onClose={handleClose} />
		</>
	);
};
